import React from 'react';

function Bullet(props) {

  return (
    <svg version="1.1" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <path d="m23.811 0.52758s-10.364 60.636 24.126 39.648c34.491-20.988-24.126-39.648-24.126-39.648zm95.662 23.283s-60.636-10.364-39.648 24.126c20.988 34.491 39.648-24.126 39.648-24.126zm-52.877 9.0915s-7.2411 26.941-33.693 20.503c26.695 6.4972 20.503 33.693 20.503 33.693s6.9984-27 33.693-20.503c-26.695-6.4972-20.503-33.693-20.503-33.693zm-37.872 28.579c-15.877-3.9889-28.195 34.708-28.195 34.708s60.636 10.364 39.648-24.126c-3.9352-6.467-7.789-9.6612-11.453-10.582zm58.375 14.208c-3.6771-0.86621-8.5677 0.19979-15.035 4.135-34.491 20.988 24.126 39.648 24.126 39.648s6.8427-40.03-9.0915-43.783z" stroke-width=".65424"/>
    </svg>
  );

}

export default Bullet;